const NO_VIDEOS = 'No videos yet'

export default NO_VIDEOS
